import React from 'react';
import { useUser } from '../contexts/UserContext';

const DashboardStaff: React.FC = () => {
    const { user } = useUser();
    const firstName = user?.fullName?.trim().split(' ')[0];
    const greeting = firstName ? `Welcome back, ${firstName}` : 'Welcome back';

    return (
        <div style={{ padding: 24 }}>
            <h1>{greeting}</h1>
            <p>Here's your schedule overview. Your appointments and daily activity will appear here.</p>
        </div>
    );
};

export default DashboardStaff;
